import React, {ReactNode} from 'react';
import {Container, DecisionButtons, DecisionButton} from "./ModalFooterStyles";
import {CSSProperties} from "styled-components";

interface IProps {
    children?: ReactNode
    applyText: string
    onApplyClick?: React.MouseEventHandler
    cancelText?: string
    onCancelClick?: React.MouseEventHandler
    style?: CSSProperties
    buttonBoxStyle?: CSSProperties,
    disabled_apply_button?: boolean
}

function ModalFooter(
    {
        children,
        applyText,
        onApplyClick,
        cancelText,
        onCancelClick,
        style,
        buttonBoxStyle,
        disabled_apply_button
    }: IProps
) {
    const disabled_style = {
        cursor: 'not-allowed'
    }
    //const handleOnApplyClick = disabled_apply_button ? () => {} : (e: any) => onApplyClick?.(e);
    const handleOnApplyClick = (e: any) => {
        if (typeof onApplyClick === 'function') {
            onApplyClick(e);
        }
    };

    return (
        
        <Container style={style}>
            {children}
            <DecisionButtons style={buttonBoxStyle}>
                {cancelText && <DecisionButton onClick={(e) => onCancelClick?.(e)} action="cancel">{cancelText}</DecisionButton>}
                <DecisionButton onClick={ handleOnApplyClick } action="apply">{applyText}</DecisionButton>
            </DecisionButtons>
        </Container>
    );
}

export default ModalFooter;
